import { Flex, Layout } from 'antd';

import { IncrementalityFilter } from 'components/Incrementality/IncrementalityFilter';
import { IncrementalitySidebar } from 'components/Incrementality/IncrementalitySidebar';
import { IncrementalityTable } from 'components/Incrementality/IncrementalityTable';
import { Button } from 'components/common';

import { usePerformance } from 'modules/performance/usePerformance';

export const Incrementality = ({ openGlobalFilter }: { openGlobalFilter: () => void }) => {
  const { pickIncrementalityFilter, incrementalityFilters, incrementalities } = usePerformance();

  const checkPositiveIncrementality = () => {
    return incrementalities && incrementalities.length
      ? incrementalities[0].incrementality_lift >= 0
      : true;
  };

  return (
    <>
      <Flex gap="small" align="center" justify="space-between" className="h-[52px] pl-6 pr-3 pt-3 ">
        <Flex gap="large">
          <div className="justify-start items-center gap-1.5 flex">
            <div className="w-2 h-2 bg-primary-electric-500 rounded-full" />
            <div className="text-base-sm font-medium leading-tight">Exposed conversion rate</div>
          </div>
          <div className="justify-start items-center gap-1.5 flex">
            <div className="w-2 h-2 bg-primary-gray-200 rounded-full" />
            <div className="text-base-sm font-medium leading-tight">Control conversion rate</div>
          </div>
        </Flex>
        <Flex gap="small">
          <IncrementalityFilter
            onChange={pickIncrementalityFilter}
            incrementalityFilter={incrementalityFilters}
          />
          <Button size="md" className="ml-6 " onClick={openGlobalFilter}>
            Choose new campaign
          </Button>
        </Flex>
      </Flex>
      {checkPositiveIncrementality() ? (
        <Layout className="p-4 bg-white">
          <Layout className="bg-white">
            <IncrementalityTable />
          </Layout>
          <IncrementalitySidebar />
        </Layout>
      ) : (
        <div className="w-full min-h-128 py-16 flex flex-col items-center gap-6">
          <div className="w-96 text-primary-gray-300 text-heading-2xl font-semibold leading-[30px] tracking-tighter">
            There is not enough statistically relevant data to provide insights at this time.
          </div>
        </div>
      )}
    </>
  );
};
